import { Injectable } from '@angular/core';
import moment, { Moment } from 'moment';

import { DatahubService } from './datahub.service';

@Injectable({
  providedIn: 'root',
})
export class TimeoutService {
  private readonly expirationBufferMs: number = 1000 * 60 * 60 * 12;
  private timestamp: Moment | undefined;
  private weekendingDate: Moment | undefined;
  private interval: NodeJS.Timeout | undefined;

  private readonly outOfWeekBoundsMsg = `Only General Foreman can edit timesheets outside of the current week.`;
  private readonly outOfTimestampBufferMsg = `You have been idle on this page for a while, so we've sent you back to the home page.`;

  constructor(private readonly datahub: DatahubService) {}

  public registerTimeout(weekendingDate: Moment) {
    //generate a timestamp and save weekending date, start interval
    this.weekendingDate = weekendingDate;
    this.timestamp = moment().add(this.expirationBufferMs, 'milliseconds');
    this.interval = setInterval(() => {
      this.checkTimeout();
    }, 10000); //check every 10 seconds.
    this.checkTimeout();
  }

  public cancelTimeout() {
    //remove interval, reset variables
    this.interval = undefined;
    this.timestamp = undefined;
    this.weekendingDate = undefined;
  }

  private checkTimeout() {
    //actions that occur on interval. Check if current time is within week and acceptable limit of timestamp.
    const now = moment();
    if (!now.isSame(this.weekendingDate, 'week')) {
      this.handleTimeoutViolation(this.outOfWeekBoundsMsg);
    } else if (now.isAfter(this.timestamp)) {
      this.handleTimeoutViolation(this.outOfTimestampBufferMsg);
    }
  }

  private handleTimeoutViolation(msg: string) {
    //what is actually done when a timeout violation has occurred. We send them back to the homepage.
    this.datahub.resetApplicationState(msg);
  }
}
